<template>
  <div class="popup-adress">
    <van-popup v-model="show" position="bottom" :style="{ height: '35%' }" @close="closePopup">
      <dr-column class="bottle-box" justifyContent="space-between" alignItems="center">
        <dr-row v-if="title" style="width:100%" justifyContent="space-between" alignItems="center">
          <div class="title-name">{{ title }}</div>
          <van-icon name="static/imgs/delete_icon.png" size="16" @click="closePopup" />
        </dr-row>
        <dr-row class="margin-top19" style="height:80%;width:100%;overflow: auto;" justifyContent="space-between" alignItems="center">
          <div :class="item.id == defaultVal?'selet-items-active':'selet-items'" 
          v-for="(item, index) in list" :key="index" 
          @click="seletItem(item,index)"
          >{{ item.name }}</div>
        </dr-row>
      </dr-column>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type:String,
      default:''
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    defaultVal:{
      type: Number,
      default: 0,
    }
  },
  watch: {
    show: {
      handler (val) {
        this.isShow = val
      },
      immediate: true
    },
    defaultVal: {
      handler (val) {
        this.defaultVal = val
      },
      immediate: true
    }
  },
  data () {
    return {
      isShow: false,
      acticeIndex:0
    }
  },
  methods: {
    closePopup () {
      console.log('');
      this.$emit('update:show', false)
    },
    seletItem(item,index) {
      this.acticeIndex = index
      this.$emit('update:defaultVal', item.id)
      this.$emit('confirm',this.list[this.acticeIndex].id,this.acticeIndex)
    },
  },
}
</script>
<style scoped>
.tips-text {
  font-size: 19px;
  color: #000000;
}

.margin-left36 {
  margin-left: 36px;
}

.bottle-box {
  padding: 14px 14px 20px 14px;
  box-sizing: border-box;
  height: 100%;
}

.title-name {
  font-size: 18px;
  color: #111111;
}

.selet-items {
  width: 48.5%;
  background: #F1F1F1;
  border: 1px solid #F1F1F1;
  text-align: center;
  padding: 15px 0;
  font-size: 15px;
  margin-bottom: 10px;
  border-radius: 10px;
}

.selet-items-active {
  width: 48.5%;
  background: #C1D7FF;
  border: 1px solid #0046CB;
  text-align: center;
  padding: 15px 0;
  margin-bottom: 10px;
  color: #0046CB;
  font-size: 15px;
  border-radius: 10px;
}
.margin-top19 {
  margin-top: 19px;
}
</style>

<style>
.bottle-popup .van-picker-column__item--selected {
  color: #0046CB;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/drSeletItem/index.vue